<template>
  <div class='h100-40 width-100vw h-scroll'>
    <ejs-grid :dataSource="dataSourceOfBatchManagement" ref='gridOfBatchImport' :rowSelected='rowSelectedOfBatch' :actionComplete='actionComplete' height='calc(100% - 0px)' :allowReordering='true' :allowResizing='true' >
      <e-columns>
        <e-column field='taskName' :headerText='this.$t("MCS.taskName")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskType' :headerText='this.$t("MCS.taskType")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='taskTypeFormatter'></e-column>
        <e-column field='createTime' :headerText='this.$t("MCS.createTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='createTimeFormatter'></e-column>
        <e-column field='updateTime' :headerText='this.$t("MCS.updateTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='updateTimeFormatter'></e-column>
        <e-column field='taskStatus' :headerText='this.$t("MCS.taskStatus")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter="taskStatusFormatter"></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pagerOfBatchManagement' @click='getBatchList(false)' :currentPage='page.currentPage' :pageSize='page.pageSize' :totalRecordsCount='page.totalRecordsCount' :pageCount='page.pageCount'></ejs-pager>
    <CustomDialog ref='importForBatchManagement' :element='importForBatchManagementSetting.element' :styles='importForBatchManagementSetting.styles'>
      <template v-slot:dialog-content>
        <BatchManagementImport ref='batchManagementImport'></BatchManagementImport>
      </template>
    </CustomDialog>
    <CustomDialog ref='modifyForBatchManagement' :element='modifyForBatchManagementSetting.element' :styles='modifyForBatchManagementSetting.styles'>
      <template v-slot:dialog-content>
        <batchManagementModify ref='batchManagementModify'></batchManagementModify>
      </template>
    </CustomDialog>
    <CustomDialog ref='batchImportDetail' :element='dialogForBatchDetail.element' :styles='dialogForBatchDetail.style'>
      <template v-slot:dialog-content>
        <BatchDetailDialog ref="batchDetail"></BatchDetailDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='downloadDialog' :element='dialogForTemplateDownload.element' :styles='dialogForTemplateDownload.style'>
      <template v-slot:dialog-content>
        <TemplateDownloadDialog ref="templateDownload"></TemplateDownloadDialog>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
  import { Reorder, Resize, ContextMenu } from '@syncfusion/ej2-vue-grids';
  import CustomDialog from '../../../common/CustomDialog';
  import BatchManagementImport from './BatchManagementImport';
  import batchManagementModify from './BatchManagementModify';
  import DateUtil from '../../../pmConfig/util/DateUtil';
  import TemplateDownloadDialog from './dialog/TemplateDownloadDialog'
  import BatchDetailDialog from './dialog/BatchDetailDialog'
  import {EventBus} from "../../../../plugins/eventBus";

  export default {
    name: "BatchManagementTable",
    components: {
      BatchManagementImport,
      CustomDialog,
      BatchDetailDialog,
      TemplateDownloadDialog,
      batchManagementModify
    },
    data() {
      return {
        dataSourceOfBatchManagement: [],
        page: {
          currentPage: 1,
          pageSize: 20,
          totalRecordsCount: 0,
          pageCount: 10
        },
        importForBatchManagementSetting: {
          styles: {
            width: '810px',
            height: 'auto',
            model: true,
            visible: false
          },
          element: {
            title: this.$t("MCS.batchImportManagement"),
            refName: 'importForBatchManagement',
            isClose: true,
            buttonGroup: [
              { click: this.closeDialog, buttonModel: { content: this.$t('Common.cancel') } },
              { click: this.importCommit, buttonModel: { content: this.$t('Common.ok'), isPrimary: true } }
            ]
          }
        },

        modifyForBatchManagementSetting: {
          styles: {
            width: '810px',
            height: 'auto',
            model: true,
            visible: false
          },
          element: {
            title: this.$t("MCS.batchImportManagement"),
            refName: 'batchImportModify',
            isClose: true,
            buttonGroup: [
              { click: this.closeModifyDialog, buttonModel: { content: this.$t('Common.cancel') } },
              { click: this.modifyCommit, buttonModel: { content: this.$t('Common.ok'), isPrimary: true } }
            ]
          }
        },
        dialogForBatchDetail: {
          style: {
            width: '950px',
            height: '645px',
            visible: false,
            model: true
          },
          element: {
            title: this.$t("MCS.batchManagementDetail"),
            refName: 'detailForBatchManagement',
            buttonGroup: [
              { click: this.closeBatchDetailPage, buttonModel: { content: this.$t('Common.ok'), isPrimary: true} }
            ],
            isClose: true
          }
        },
        dialogForTemplateDownload: {
          style: {
            width: '800px',
            height: '645px',
            visible: false,
            model: true
          },
          element: {
            title: this.$t("MCS.templateDownload"),
            refName: 'downloadForBatchManagement',
            buttonGroup: [
              { click: this.closeDownloadDialog, buttonModel: { content: this.$t('Common.cancel') } },
              { click: this.downloadTemplate, buttonModel: { content: this.$t('Common.ok'), isPrimary: true } }
            ],
            isClose: true
          }
        },

        taskStatus: new Map()
          .set(0, this.$t("MCS.waitting"))
          .set(1, this.$t("MCS.running"))
          .set(2, this.$t("MCS.filed"))
          .set(3, this.$t("MCS.complate"))
          .set(4, this.$t("MCS.cancel")),
        taskType: new Map()
          .set(0, this.$t("Common.export"))
          .set(1, this.$t("Common.import"))
      }
    },
    methods: {
      actionComplete(){
        this.$refs.gridOfBatchImport.selectRow(0,true);
        this.$refs.gridOfBatchImport.selectRow(0,true);
      },
      taskTypeFormatter(grids, data) {
        return this.taskType.get(data.taskType);
      },
      taskStatusFormatter(grids, data) {
        return this.taskStatus.get(data.taskStatus);
      },
      rowSelectedOfBatch(msg) {
        this.$emit('taskStatusChange', msg.data.taskStatus);
      },
      createTimeFormatter(grids, data) {
        let date = new Date(data.createTime);
        return DateUtil.getDateString(date);
      },
      updateTimeFormatter(grids, data) {
        let date = new Date(data.updateTime);
        return DateUtil.getDateString(date);
      },
      import() {
        this.$refs.importForBatchManagement.show();
        this.$refs.batchManagementImport._getNeTreeData();
      },
      refresh() {
        this.getBatchList(true);
      },

      delete() {
        let delList = [];
        const selectedRecords = this.$refs.gridOfBatchImport.getSelectedRecords();

        if (selectedRecords.length <= 0 || selectedRecords >1) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('MCS.onlyData') });
          return;
        }
        for(let i = 0; i < selectedRecords.length; i++) {
          delList.push(selectedRecords[i].taskId);
        }

        let params = {};
        params.list = delList;
        this.$layer.confirm({
          msg: `${this.$t('Common.tips.confirmTip')}`,
          btn1: {
            msg: `${this.$t('Common.cancel')}`
          },
          btn2: {
            msg: `${this.$t('Common.ok')}`,
            func: () => {
              this.$axios.post('/lte/ems/subscriber/task/delete',params).then(response => {
                console.log(response);
                this.getBatchList(true);
              });
            }
          }
        })
      },

      modify() {

        const selectedRecords = this.$refs.gridOfBatchImport.getSelectedRecords();
        if (selectedRecords.length <= 0 || selectedRecords >1) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('MCS.onlyData') });
          return;
        }

        this.$refs.batchManagementModify.modifyTaskName = selectedRecords[0].taskName;


        this.$refs.modifyForBatchManagement.show();
      },

      start() {
        const selectedRecords = this.$refs.gridOfBatchImport.getSelectedRecords();
        if (selectedRecords.length <= 0 || selectedRecords >1) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('MCS.onlyData') });
          return;
        }
        let taskId = selectedRecords[0].taskId;
        this.$axios.post('/lte/ems/subscriber/mcs/batch/start',{
          taskId: taskId
        }).then(response => {
          if(response.data.errorCode == '0'){
            this.getBatchList(true);
          } else {
            EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
            this.getBatchList(true);
          }
        });
      },

      cancel() {
        const selectedRecords = this.$refs.gridOfBatchImport.getSelectedRecords();
        if (selectedRecords.length <= 0 || selectedRecords >1) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('MCS.onlyData') });
          return;
        }
        let taskId = selectedRecords[0].taskId;
        this.$axios.post('/lte/ems/subscriber/mcs/batch/cancel',{
          taskId: taskId
        }).then(response => {
          if(response.data.errorCode == '0'){
            this.getBatchList(true);
          } else {
            EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
            this.getBatchList(true);
          }
        });
      },

      detail(){
        const selectedRecords = this.$refs.gridOfBatchImport.getSelectedRecords();
        if (selectedRecords.length <= 0 || selectedRecords >1) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('MCS.onlyData') });
          return;
        }
        let taskId = selectedRecords[0].taskId;
        const This = this;
        this.$axios.post("/lte/ems/subscriber/mcs/batch/getBatchDetailList",{
          pageNo: 1,
          pageSize: 10000,
          taskId: taskId
        }).then((response) => {
          console.log(response);
          const result = response.data.resultVal;
          This.$refs.batchDetail.dataSourceOnBatchDetail = result.result;
        });
        this.$refs.batchImportDetail.show();
      },

      closeBatchDetailPage() {
        this.$refs.batchImportDetail.close();
      },

      closeModifyDialog() {
        this.$refs.modifyForBatchManagement.clear();
        this.$refs.modifyForBatchManagement.close();
      },

      modifyCommit(){
        const file = this.$refs.batchManagementModify.importModifyFile; // null
        if(file == null){
          EventBus.$emit('toast', { type: 'warning', content: this.$t('System.selectFile') });
          return;
        }
        const selectedRecords = this.$refs.gridOfBatchImport.getSelectedRecords();
        if (selectedRecords.length <= 0 || selectedRecords >1) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('MCS.onlyData') });
          return;
        }
        let taskId = selectedRecords[0].taskId;
        const isCover = this.$refs.batchManagementModify.isModifyCover;
        const blacklistDealType = this.$refs.batchManagementModify.blacklistModifyDealType;
        const relationsDealType = this.$refs.batchManagementModify.relationsModifyDealType;
        const areasDealType = this.$refs.batchManagementModify.areasMofidyDealType;

        const formData = new FormData();
        formData.append('file', file);
        formData.append('taskId', taskId);

        formData.append('duplicateMode', isCover);
        formData.append('blacklist', blacklistDealType);
        formData.append('relations', relationsDealType);
        formData.append('areas', areasDealType);

        let config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };

        this.$axios.post('/lte/ems/subscriber/mcs/batch/modify', formData, config).then(response => {
          if(response.data.errorCode == '0'){
            this.getBatchList();
          } else {
            EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
            this.getBatchList();
          }
        });
        this.$refs.modifyForBatchManagement.clear();
        this.$refs.modifyForBatchManagement.close();
      },

      closeDialog() {
        this.$refs.importForBatchManagement.clear();
        this.$refs.importForBatchManagement.close();
      },

      importCommit() {
        const file = this.$refs.batchManagementImport.importFile; // null
        if(file == null){
          EventBus.$emit('toast', { type: 'warning', content: this.$t('System.selectFile') });
          return;
        }
        const isCover = this.$refs.batchManagementImport.isCover;
        const importType = this.$refs.batchManagementImport.importType;

        const checkNodes = this.$refs.batchManagementImport.$refs.listNe.getSelectedRecords(); //checkNodes.length
        if(checkNodes.length <= 0){
          EventBus.$emit('toast', { type: 'warning', content: this.$t('Track.pleaseSelectNE') });
          return;
        }

        const taskName = this.$refs.batchManagementImport.taskName;  //""
        if(taskName == '' || taskName == null){
          EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.taskNameNull') });
          return;
        }

        const blacklistDealType = this.$refs.batchManagementImport.blacklistDealType;
        const relationsDealType = this.$refs.batchManagementImport.relationsDealType;
        const areasDealType = this.$refs.batchManagementImport.areasDealType;

        const formData = new FormData();
        formData.append('file', file);
        formData.append('duplicateMode', isCover);

        formData.append('blacklist', blacklistDealType);
        formData.append('relations', relationsDealType);
        formData.append('areas', areasDealType);

        formData.append('importType', importType);
        formData.append('taskName', taskName);
        formData.append('checkNode', checkNodes[0].id);

        let config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };

        this.$axios.post('/lte/ems/subscriber/mcs/batch/import', formData, config).then(response => {
          if(response.data.errorCode == '0'){
            this.getBatchList();
          } else {
            EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
            this.getBatchList();
          }
        });
        this.$refs.importForBatchManagement.clear();
        this.$refs.importForBatchManagement.close();
      },
      getBatchList(firstFlag){
        const This = this;

        if(firstFlag){
          This.page.currentPage = 1;
        } else {
          This.page.currentPage = This.$refs.pagerOfBatchManagement.ej2Instances.currentPage;
        }
        this.$axios.post("/lte/ems/subscriber/mcs/batch/getBatchList",{
          pageNo: This.page.currentPage,
          pageSize: This.page.pageSize
        }).then((response) => {
          console.log(response);
          const result = response.data.resultVal;
          This.page.totalRecordsCount = result.totalCount;
          This.page.currentPage = result.pageNo;
          This.dataSourceOfBatchManagement = result.result;
          console.log(This.dataSourceOfBatchManagement);
          this.$emit('taskStatusChange', 6);
        });
      },

      download(){
        this.$refs.downloadDialog.show();
        this.$refs.templateDownload.getGMSList();
      },

      closeDownloadDialog() {
        this.$refs.downloadDialog.clear();
        this.$refs.downloadDialog.close();
      },

      downloadTemplate(){
        const checkNodes = this.$refs.templateDownload.$refs.listNe.getSelectedRecords();
        if(checkNodes.length <= 0){
          EventBus.$emit('toast', { type: 'warning', content: this.$t('Track.pleaseSelectNE') });
          return;
        }
        const params = {
        }
        const config = {
          responseType: 'blob'
        };
        this.$loading.showLoadding(this.$t('Software.downloading'));
        this.$axios.post(`/lte/ems/subscriber/mcs/batch/templateDownload.html?templateId=${checkNodes[0].id}`, params, config).then((res) => {
          const link = document.createElement('a');
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          const fileName = 'template.xlsx';
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.$loading.hideLoadding();

          this.$refs.downloadDialog.clear();
          this.$refs.downloadDialog.close();
        });
      }
    },
    mounted() {
      this.getBatchList(true);
    },
    provide: {
      grid: [Reorder, Resize, ContextMenu]
    }
  }
</script>
